import { cn } from '@/lib/utils';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function EmptyState({ text, className }: { text?: string | ReactNode; className?: string }) {
  const { t } = useTranslation();
  return (
    <div className={cn('w-full h-full bg-white dark:bg-[#52606d] flex justify-center items-center flex-col', className)}>
      {text || t('alarms.emptyState.noAlarms')}
    </div>
  );
}
